import { useTranslation } from 'react-i18next'
import { AppShell } from '../components/AppShell'
import { useModule } from '../contexts/ModuleContext'
import { Icon } from '../components/ui/icon'

export function ModulePlaceholderPage() {
  const { t } = useTranslation()
  const { currentModule } = useModule()

  const allItems = currentModule.nav.flatMap((s) => s.items)

  return (
    <AppShell crumbs={[{ label: currentModule.label }, { label: 'Overview' }]}>
      <div className="ad-page">
        <div className="module-empty">
          <span className="module-empty__icon" style={{ background: currentModule.accent }}>
            <Icon name={currentModule.icon} className="size-8" />
          </span>
          <div className="module-empty__title">{currentModule.label}</div>
          <div className="module-empty__text">
            This is the <strong>{currentModule.label}</strong> module &mdash;{' '}
            {currentModule.blurb.toLowerCase()}. {t('modulePlaceholder.body')}
          </div>
          <div className="module-empty__nav">
            {allItems.map((it) => (
              <span key={it.id} className="module-empty__chip">
                <Icon name={it.icon} className="size-4" />
                {it.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  )
}
